module.exports = __webpack_public_path__ + "img/face-smile.c003a055.svg";